import { createSlice } from "@reduxjs/toolkit";
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {
      access_token: localStorage.getItem('access_token')
    },
    check: null,
    cellphone: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setCellphone: (state, action) => {
      state.cellphone = action.payload
    }
  },
});
